import styled from "styled-components"
import { Text } from "./index"

const UList = styled.ul`
  list-style: none;
  padding-left: 0;

  ${Text} {
    margin-top: 0.5em;
  }
`

export default UList
